// extracted by mini-css-extract-plugin
export default {"placeholder":"DBDropDown_placeholder__nex7h","dropdown":"DBDropDown_dropdown__qU38J"};